const utils = {
  getCart: function() {
    return $.getJSON('/cart.js');
  },
  
  observeMutations: function(elementSelector, callback) {
    if (document.querySelectorAll(elementSelector).length == 0) {
      return;
    }
    var observer = new MutationObserver(callback);
    var config = { attributes: true, childList: true, characterData: false };
    observer.observe(document.querySelector(elementSelector), config);

    return observer;
  },
  
  formatMoney: function(value) {
    return theme.Currency.formatMoney(value, theme.settings.moneyFormat);
  }
}